// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"316":"9240c87a6e7efdfd4c8d","675":"22280e0c6533fa21000b"}[chunkId] + ".js";
};